import openFund from './open-fund';
import fundRequests from './fund-requests';

export default {
  namespaced: true,
  modules: {
    openFund,
    fundRequests,
  },
};
